import { SystemEntity } from '@wdx/shared/swagger-gen';

export function lowerCaseSystemEntityMap(): Record<string, SystemEntity> {
    return Object.keys(SystemEntity).reduce(
        (prev, curr) => ({ ...prev, [curr.toLowerCase()]: curr }),
        {},
    );
}
